import axios from "axios";

export default function setNotificationSettings({
  enabled,
  emails,
}) {
  return new Promise((resolve, reject) =>
    axios
      .put(`/notification/system-admin/api/v1/tngReportNotificationSetting`, {
        enabled, emails
      })
      .then((response) => resolve(response.data))
      .catch((error) => reject(error.message))
  );
}
